(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynamic-category-content-coloured-lab-color"] && !Shopify.designMode) return;
  try {
    /* =========================
   FAQ JSON-LD SCHEMA (SHARED, HANDLE AWARE)
   Every category block is printed on every collection page and only
   the one matching the current handle is un-hidden. The schema is
   therefore built from the FAQ block that is actually visible, so a
   page never publishes another category's questions.
========================= */

window.pcFaqSchema = window.pcFaqSchema || (function () {
  var SCRIPT_ID = 'pc-faq-schema';
  var pending = null;

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
      node = node.parentElement;
    }
    return true;
  }

  function build() {
    pending = null;

    var handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var current = document.getElementById(SCRIPT_ID);

    // A Liquid-rendered FAQPage for this exact collection is already in the
    // page source and is authoritative, so leave it untouched. The builder
    // only takes over after client-side navigation, and on the per-shape
    // pages whose FAQs come from the JSON asset.
    if (current && current.getAttribute('data-faq-handle') === handle) return;

    var mainEntity = [];
    var seen = {};

    document.querySelectorAll('[data-faq-schema]').forEach(function (block) {
      if (!isVisible(block)) return;

      block.querySelectorAll('.faq-item').forEach(function (item) {
        var questionEl = item.querySelector('.faq-question');
        var answerEl = item.querySelector('.faq-answer');
        if (!questionEl || !answerEl) return;

        var name = clean(questionEl.textContent);
        var text = clean(answerEl.innerHTML);
        var key = name.toLowerCase();
        if (!name || !text || seen[key]) return;

        seen[key] = true;
        mainEntity.push({
          '@type': 'Question',
          name: name,
          acceptedAnswer: { '@type': 'Answer', text: text }
        });
      });
    });

    var script = current;

    if (!mainEntity.length) {
      if (script) script.remove();
      return;
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    var pageUrl = (canonical && canonical.href) || (window.location.origin + window.location.pathname);

    var payload = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#faq',
      url: pageUrl,
      mainEntity: mainEntity
    });

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = SCRIPT_ID;
      document.head.appendChild(script);
    } else {
      script.removeAttribute('data-faq-handle');
    }

    if (script.textContent !== payload) script.textContent = payload;
  }

  return {
    sync: function () {
      if (pending !== null) return;
      pending = window.requestAnimationFrame
        ? window.requestAnimationFrame(build)
        : window.setTimeout(build, 0);
    }
  };
})();

let isColouredLabDynamicLoading = false;

/* =========================
   MAIN LOAD FUNCTION
========================= */

async function loadDynamicColouredLabContent() {
  try {
    const container = document.getElementById('dynamic-category-content-coloured-lab');
    if (!container) return;

    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];
    const handleParent = path[path.length - 2] || '';

    // Every category block is printed on every collection page, so the trailing
    // shape segment on its own is ambiguous: /collections/lab-diamonds/round and
    // /collections/coloured-lab-grown-diamonds/round both end in 'round'. Key the
    // render on parent + handle so switching family client-side re-renders
    // instead of short-circuiting on a stale match.
    const currentRenderKey = `${handleParent}/${handle}`;

    // Check if already rendered for this URL to prevent duplicate runs & infinite mutation loops
    if (container.dataset.renderedHandle === currentRenderKey) {
      return;
    }

    if (isColouredLabDynamicLoading) return;
    isColouredLabDynamicLoading = true;

    const diamonds = [
      'round','oval','pear','princess','asscher',
      'heart','emerald','radiant','cushion','marquise',
      'coloured-lab-grown-diamonds'
    ];

    const displayNames = {
      'coloured-lab-grown-diamonds': { h1: 'Coloured', h2: 'coloured' }
    };

    const seoContent = document.getElementById('coloured-lab-diamonds-seo-content');

    if (handle === 'coloured-lab-grown-diamonds') {
      if (seoContent) seoContent.style.display = 'block';
      container.style.display = 'none';
      initColouredLabFaqToggle();
      container.dataset.renderedHandle = currentRenderKey;
      isColouredLabDynamicLoading = false;
      return;
    }

    if (seoContent) seoContent.style.display = 'none';

    // A shape page only belongs to this block when the parent segment is
    // 'coloured-lab-grown-diamonds'. Without this check the same 'round' handle
    // also opens the lab and natural blocks, printing the FAQ two more times.
    if (handleParent !== 'coloured-lab-grown-diamonds' || !diamonds.includes(handle)) {
      container.style.display = 'none';
      container.dataset.renderedHandle = currentRenderKey;
      isColouredLabDynamicLoading = false;
      return;
    }

    // Fetched only for shape pages, so the base-page help/FAQ above never depends on the JSON loading.
    // A missing asset input, a 404 or an unreadable body all fall through to the
    // "no content" branch below, which records this route as handled. Without that,
    // the body-wide MutationObserver re-runs this loader - and re-fetches - on every DOM change.
    const assetInput = document.getElementById("coloured-dynamic-asseturl");
    let data = null;
    if (assetInput && assetInput.value) {
      try {
        const response = await fetch(assetInput.value);
        if (response.ok) data = await response.json();
      } catch (jsonErr) {
        console.warn('Coloured lab diamonds: could not load dynamic-category-content-coloured-lab.json', jsonErr);
      }
    }

    const content = data?.[`${handle}-lab-diamonds`];
    if (!content) {
      container.style.display = 'none';
      container.dataset.renderedHandle = currentRenderKey;
      isColouredLabDynamicLoading = false;
      return;
    }

    container.style.display = 'block';

    /* =========================
       HANDLE TEXT
    ========================= */

    const nameMap = displayNames[handle];
    const handle1Text = nameMap ? nameMap.h1 : handle.charAt(0).toUpperCase() + handle.slice(1);
    const handle2Text = nameMap ? nameMap.h2 : handle;

    container.querySelectorAll('.coloured-dynamic-handle-1')
      .forEach(el => el.innerText = handle1Text);

    container.querySelectorAll('.coloured-dynamic-handle-2')
      .forEach(el => el.innerText = handle2Text);

    /* =========================
       HIDE SHAPE-SPECIFIC STATIC BLOCKS FOR COMPOUND HANDLES
    ========================= */

    container.querySelectorAll('.faq-item').forEach((el, i) => {
      el.style.display = (nameMap && i > 0) ? 'none' : '';
    });

    /* =========================
       CONTENT INJECTION
    ========================= */

    const titleEl = container.querySelector('#coloured-cat-title');
    const introEl = container.querySelector('#coloured-cat-intro');
    const faqBlock = container.querySelector('#coloured-dynamic-faq-block');

    if (titleEl) titleEl.innerHTML = content.title || '';
    if (introEl) introEl.innerHTML = content.description || '';

    if (faqBlock) {
      let blockHtml = '';

      if (nameMap && Array.isArray(content.sections)) {
        blockHtml += content.sections.map(s => `
          <div class="faq-item">
            <div class="h5 faq-question mb-0">
              <span>${s.title}</span>
              <span class="faq-icon"><i class="icon-plus"></i></span>
            </div>
            <div class="faq-answer">${s.content}</div>
          </div>
        `).join('');
      }

      if (Array.isArray(content.faqs)) {
        blockHtml += `
          <div class="faq-container" data-faq-schema>
            <h3 class="h2 text-center my-5">Frequently Asked Questions</h3>
            ${content.faqs.map((f, i) => `
              <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
                <div class="h5 faq-question mb-0">
                  <span>${f.q}</span>
                  <span class="faq-icon"><i class="icon-plus"></i></span>
                </div>
                <div class="faq-answer">${f.a}</div>
              </div>
            `).join('')}
          </div>
        `;
      }

      if (blockHtml) faqBlock.innerHTML = blockHtml;
    }

    container.dataset.renderedHandle = currentRenderKey;
    initColouredLabFaqToggle();

  } catch (err) {
    console.error('Coloured Lab Dynamic Error:', err);
  } finally {
    isColouredLabDynamicLoading = false;
    window.pcFaqSchema.sync();
  }
}

/* =========================
   FAQ TOGGLE SAFE VERSION
========================= */

function initColouredLabFaqToggle() {
  const container = document.getElementById('dynamic-category-content-coloured-lab');
  const seoContent = document.getElementById('coloured-lab-diamonds-seo-content');

  const queryAndInit = (parent) => {
    if (!parent) return;
    parent.querySelectorAll('.faq-question').forEach(item => {
      if (item.dataset.listener === "true") return;
      item.dataset.listener = "true";

      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        let icon = item.querySelector('.faq-icon i') || item.querySelector('i');
        if (!answer) return;

        const isOpen = answer.classList.contains('active');

        parent.querySelectorAll('.faq-answer')
          .forEach(a => a.classList.remove('active'));

        parent.querySelectorAll('.faq-question i')
          .forEach(i => i.className = 'icon-plus');

        if (!isOpen) {
          answer.classList.add('active');
          if (icon) icon.className = 'icon-minus';
        }
      });
    });
  };

  queryAndInit(container);
  queryAndInit(seoContent);
}

/* =========================
   INITIAL LOAD & OBSERVER
========================= */

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  loadDynamicColouredLabContent();
} else {
  document.addEventListener('DOMContentLoaded', loadDynamicColouredLabContent);
}

if (typeof window.colouredLabObserver === 'undefined') {
  window.colouredLabObserver = new MutationObserver(() => {
    const container = document.getElementById('dynamic-category-content-coloured-lab');
    if (container) {
      const path = window.location.pathname.split('/').filter(Boolean);
      const handle = path[path.length - 1];
      const handleParent = path[path.length - 2] || '';
      if (container.dataset.renderedHandle !== `${handleParent}/${handle}`) {
        loadDynamicColouredLabContent();
      }
    }
  });
  window.colouredLabObserver.observe(document.body, { childList: true, subtree: true });
}

/* =========================
   SHOPIFY AJAX SAFE NAV
========================= */

if (typeof window.__pcUrlChangePatched === 'undefined') {
  window.__pcUrlChangePatched = true;
  (function () {
    ['pushState','replaceState'].forEach(method => {
      const original = history[method];
      history[method] = function () {
        original.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };
    });
    window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('urlChange'));
    });
  })();
}

window.addEventListener('urlChange', () => {
  setTimeout(() => {
    loadDynamicColouredLabContent();
  }, 100);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-engagement-rings"] && !Shopify.designMode) return;
  try {
    /* =========================
   FAQ JSON-LD SCHEMA (SHARED, HANDLE AWARE)
   Every category block is printed on every collection page and only
   the one matching the current handle is un-hidden. The schema is
   therefore built from the FAQ block that is actually visible, so a
   page never publishes another category's questions.
========================= */

window.pcFaqSchema = window.pcFaqSchema || (function () {
  var SCRIPT_ID = 'pc-faq-schema';
  var pending = null;

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
      node = node.parentElement;
    }
    return true;
  }

  function build() {
    pending = null;

    var handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var current = document.getElementById(SCRIPT_ID);

    // A Liquid-rendered FAQPage for this exact collection is already in the
    // page source and is authoritative, so leave it untouched. The builder
    // only takes over after client-side navigation, and on the per-shape
    // pages whose FAQs come from the JSON asset.
    if (current && current.getAttribute('data-faq-handle') === handle) return;

    var mainEntity = [];
    var seen = {};

    document.querySelectorAll('[data-faq-schema]').forEach(function (block) {
      if (!isVisible(block)) return;

      block.querySelectorAll('.faq-item').forEach(function (item) {
        var questionEl = item.querySelector('.faq-question');
        var answerEl = item.querySelector('.faq-answer');
        if (!questionEl || !answerEl) return;

        var name = clean(questionEl.textContent);
        var text = clean(answerEl.innerHTML);
        var key = name.toLowerCase();
        if (!name || !text || seen[key]) return;

        seen[key] = true;
        mainEntity.push({
          '@type': 'Question',
          name: name,
          acceptedAnswer: { '@type': 'Answer', text: text }
        });
      });
    });

    var script = current;

    if (!mainEntity.length) {
      if (script) script.remove();
      return;
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    var pageUrl = (canonical && canonical.href) || (window.location.origin + window.location.pathname);

    var payload = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#faq',
      url: pageUrl,
      mainEntity: mainEntity
    });

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = SCRIPT_ID;
      document.head.appendChild(script);
    } else {
      script.removeAttribute('data-faq-handle');
    }

    if (script.textContent !== payload) script.textContent = payload;
  }

  return {
    sync: function () {
      if (pending !== null) return;
      pending = window.requestAnimationFrame
        ? window.requestAnimationFrame(build)
        : window.setTimeout(build, 0);
    }
  };
})();

let isRingsDynamicLoading = false;
let ringsOriginalMeta = null;
let ringsLastRenderKey = null;

// Clones a family sub-template's markup next to itself into the live DOM. The
// <template> tag itself is left in place (never consumed) so it can be cloned
// from again later; a no-op once already mounted. Returns false only if the
// template is missing.
function mountRingsSubTemplate(templateId, mountedId) {
  if (document.getElementById(mountedId)) return true;
  const tpl = document.getElementById(templateId);
  if (!tpl) return false;
  tpl.after(tpl.content.cloneNode(true));
  return !!document.getElementById(mountedId);
}

// Removes a previously-mounted clone from the live DOM entirely (not just
// display:none) so it can't be picked up by a crawl of a route it doesn't
// belong to. Safe to call whether or not it's currently mounted.
function unmountRingsSubTemplate(mountedId) {
  const el = document.getElementById(mountedId);
  if (el) el.remove();
}

function mountRingsDynamicTemplate() {
  return mountRingsSubTemplate('tpl-engagement-rings-dynamic', 'dynamic-category-content-ring');
}

function mountRingsSeoTemplate() {
  const mounted = mountRingsSubTemplate('tpl-engagement-rings-seo', 'engagement-rings-seo-content');
  if (mounted) {
    const el = document.getElementById('engagement-rings-seo-content');
    if (el) el.style.display = 'block';
  }
  return mounted;
}

function getRingsMetaDescriptionTag() {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  return tag;
}

function applyRingsSeo(seo) {
  const metaTag = getRingsMetaDescriptionTag();
  if (ringsOriginalMeta === null) {
    ringsOriginalMeta = { title: document.title, description: metaTag.getAttribute('content') || '' };
  }
  if (seo?.title) document.title = seo.title;
  if (seo?.description) metaTag.setAttribute('content', seo.description);
}

function restoreRingsSeo() {
  if (!ringsOriginalMeta) return;
  document.title = ringsOriginalMeta.title;
  getRingsMetaDescriptionTag().setAttribute('content', ringsOriginalMeta.description);
}

function renderRingSections(sections) {
  if (!Array.isArray(sections)) return '';

  return sections.map(function (section) {
    const listHtml = Array.isArray(section.list) && section.list.length
      ? `<ul>${section.list.map(item => `<li>${item}</li>`).join('')}</ul>`
      : '';

    const tableHtml = section.table && Array.isArray(section.table.rows)
      ? `
        <div class="faq-table-wrap">
          <table class="faq-table">
            <thead>
              <tr>${(section.table.headers || []).map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${section.table.rows.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
            </tbody>
          </table>
        </div>
      `
      : '';

    const noteHtml = section.note ? `<p class="faq-note">${section.note}</p>` : '';

    return `
      <div class="faq-subsection">
        <h2 class="faq-subheading">${section.heading || ''}</h2>
        ${section.body || ''}
        ${listHtml}
        ${tableHtml}
        ${noteHtml}
      </div>
    `;
  }).join('');
}

async function loadDynamicRingsContent() {
  try {
    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];
    const handleParent = path[path.length - 2] || '';

    // Check if already rendered for this handle to prevent duplicate runs & infinite mutation loops
    const currentRenderKey = `${handleParent}/${handle}`;
    if (ringsLastRenderKey === currentRenderKey) {
      return;
    }

    if (isRingsDynamicLoading) return;
    isRingsDynamicLoading = true;

    // This physical page also hosts the natural/lab/coloured-lab/moissanite
    // diamond flows. Only mount this family's template when the URL is
    // actually an engagement-rings route, so those other routes (and a crawl
    // of any one of them) never find this family's headings sitting inert.
    const isEngagementRingsRoute =
      (handle === 'engagement-rings' && handleParent === 'collections') ||
      handleParent === 'engagement-rings';

    if (!isEngagementRingsRoute) {
      unmountRingsSubTemplate('dynamic-category-content-ring');
      unmountRingsSubTemplate('engagement-rings-seo-content');
      unmountRingsSubTemplate('engagement-rings-help-fallback');
      restoreRingsSeo();
      ringsLastRenderKey = currentRenderKey;
      isRingsDynamicLoading = false;
      return;
    }

    // /collections/engagement-rings itself and each shape sub-page are
    // mutually exclusive: only the template matching the exact route is ever
    // cloned in, and the other is removed outright (not just hidden), so a
    // crawl of either route only ever finds the content that belongs to it.
    if (handle === 'engagement-rings' && handleParent === 'collections') {
      unmountRingsSubTemplate('dynamic-category-content-ring');
      unmountRingsSubTemplate('engagement-rings-help-fallback');
      mountRingsSeoTemplate();
      restoreRingsSeo();
      initRingsFaqToggle();
      ringsLastRenderKey = currentRenderKey;
      isRingsDynamicLoading = false;
      return;
    }

    unmountRingsSubTemplate('engagement-rings-seo-content');

    if (!mountRingsDynamicTemplate()) {
      isRingsDynamicLoading = false;
      return;
    }

    const container = document.getElementById("dynamic-category-content-ring");
    if (!container) {
      isRingsDynamicLoading = false;
      return;
    }

    const assetInput = document.getElementById("dynamic-asseturl-ring");
    if (!assetInput || !assetInput.value) {
      isRingsDynamicLoading = false;
      return;
    }

    const dynamicAssetUrl = assetInput.value;

    const rings = [
      'solitaire',
      'halo',
      'bezel',
      'hidden-halo',
      'pave',
      'side-stone',
      'three-stone',
      'nature-inspired',
      'vintage',
      'toi-et-moi',
      'unique',
    ];

    const isRing = rings.includes(handle);
    const newHandle = `${handle}-engagement-rings`;

    if (!isRing) {
      unmountRingsSubTemplate('dynamic-category-content-ring');
      unmountRingsSubTemplate('engagement-rings-help-fallback');
      restoreRingsSeo();
      ringsLastRenderKey = currentRenderKey;
      isRingsDynamicLoading = false;
      return;
    }

    // The JSON only supplies the hero/sections copy. The per-style FAQs come from
    // the templates in this snippet, so a missing or failing JSON must not hide them.
    let content = null;
    try {
      const response = await fetch(dynamicAssetUrl);
      if (response.ok) {
        const data = await response.json();
        content = data?.[newHandle] || null;
        if (!content) console.warn('Engagement rings: no "' + newHandle + '" entry in dynamic-category-content-ring.json');
      } else {
        console.warn('Engagement rings: dynamic-category-content-ring.json returned ' + response.status);
      }
    } catch (jsonErr) {
      console.warn('Engagement rings: could not load dynamic-category-content-ring.json', jsonErr);
    }

    // The route changed while the JSON was loading; a newer render owns the DOM now.
    const latestPath = window.location.pathname.split('/').filter(Boolean);
    if (`${latestPath[latestPath.length - 2] || ''}/${latestPath[latestPath.length - 1]}` !== currentRenderKey) {
      return;
    }

    container.style.display = 'block';

    const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);
    const handle2Text = handle;

    container.querySelectorAll('.ring-dynamic-handle-1')
      .forEach(el => el.innerText = handle1Text);

    container.querySelectorAll('.ring-dynamic-handle-2')
      .forEach(el => el.innerText = handle2Text);

    const titleEl = container.querySelector('#ring-cat-title');
    const introEl = container.querySelector('#ring-cat-intro');
    const sectionsBlock = container.querySelector('#ring-dynamic-sections-block');
    const faqBlock = container.querySelector('#ring-dynamic-faq-block');

    const guideItem = titleEl ? titleEl.closest('.faq-item') : null;
    if (guideItem) guideItem.style.display = content ? '' : 'none';

    // No JSON copy for this style: fall back to the full-width help section.
    if (content) {
      unmountRingsSubTemplate('engagement-rings-help-fallback');
    } else if (mountRingsSubTemplate('tpl-engagement-rings-help-fallback', 'engagement-rings-help-fallback')) {
      // Sits above the style FAQs, which follow the container in the DOM.
      const fallback = document.getElementById('engagement-rings-help-fallback');
      if (fallback && container.parentNode) container.parentNode.insertBefore(fallback, container);
    }

    if (content) {
      if (titleEl) titleEl.innerHTML = content.hero?.heading || '';
      if (introEl) introEl.innerHTML = content.hero?.intro || '';
      if (sectionsBlock) sectionsBlock.innerHTML = renderRingSections(content.sections);
      applyRingsSeo(content.seo);
    } else {
      restoreRingsSeo();
    }

    // FAQs come from the per-style <template id="tpl-er-faq-<style>"> blocks
    // (copied from dynamic-custom-faqs-engagement-rings.liquid), not the JSON asset.
    if (faqBlock) {
      faqBlock.innerHTML = '';
      const faqTpl = document.getElementById('tpl-er-faq-' + handle);
      if (faqTpl) {
        const faqWrap = document.createElement('div');
        faqWrap.setAttribute('data-faq-schema', '');
        faqWrap.appendChild(faqTpl.content.cloneNode(true));
        faqBlock.appendChild(faqWrap);
      }
    }

    ringsLastRenderKey = currentRenderKey;
    initRingsFaqToggle();

  } catch (err) {
    console.error('Error loading ring content:', err);
  } finally {
    isRingsDynamicLoading = false;
    window.pcFaqSchema.sync();
  }
}

/* =========================
   FAQ TOGGLE (SAFE VERSION)
========================= */

function initRingsFaqToggle() {
  const container = document.getElementById("dynamic-category-content-ring");
  const seoContent = document.getElementById('engagement-rings-seo-content');

  const queryAndInit = (parent) => {
    if (!parent) return;
    parent.querySelectorAll('.faq-question').forEach(item => {
      if (item.dataset.listener === "true") return;
      item.dataset.listener = "true";

      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        let icon = item.querySelector('.faq-icon i') || item.querySelector('i');
        if (!answer) return;

        const isOpen = answer.classList.contains('active');

        // Only close sibling items at this item's own nesting level (its
        // parent .faq-item's container), so opening a FAQ nested inside the
        // main guide doesn't collapse the guide panel it lives in.
        const scope = item.closest('.faq-item')?.parentElement || parent;
        scope.querySelectorAll(':scope > .faq-item > .faq-answer').forEach(a => a.classList.remove('active'));
        scope.querySelectorAll(':scope > .faq-item > .faq-question i').forEach(i => i.className = 'icon-plus');

        if (!isOpen) {
          answer.classList.add('active');
          if (icon) icon.className = 'icon-minus';
        }
      });
    });
  };

  queryAndInit(container);
  queryAndInit(seoContent);
}

/* =========================
   INITIAL LOAD & OBSERVER
========================= */

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  loadDynamicRingsContent();
} else {
  document.addEventListener('DOMContentLoaded', loadDynamicRingsContent);
}

if (typeof window.ringsObserver === 'undefined') {
  window.ringsObserver = new MutationObserver(() => {
    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1] || '';
    const handleParent = path[path.length - 2] || '';
    const currentRenderKey = `${handleParent}/${handle}`;
    if (ringsLastRenderKey !== currentRenderKey) {
      loadDynamicRingsContent();
    }
  });
  window.ringsObserver.observe(document.body, { childList: true, subtree: true });
}

/* =========================
   SHOPIFY AJAX NAV SUPPORT
========================= */

if (typeof window.__pcUrlChangePatched === 'undefined') {
  window.__pcUrlChangePatched = true;
  (function () {
    ['pushState', 'replaceState'].forEach(method => {
      const original = history[method];
      history[method] = function () {
        original.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };
    });
    window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('urlChange'));
    });
  })();
}

window.addEventListener('urlChange', () => {
  setTimeout(() => {
    loadDynamicRingsContent();
  }, 100);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-lab-diamonds"] && !Shopify.designMode) return;
  try {
    /* =========================
   FAQ JSON-LD SCHEMA (SHARED, HANDLE AWARE)
   Every category block is printed on every collection page and only
   the one matching the current handle is un-hidden. The schema is
   therefore built from the FAQ block that is actually visible, so a
   page never publishes another category's questions.
========================= */

window.pcFaqSchema = window.pcFaqSchema || (function () {
  var SCRIPT_ID = 'pc-faq-schema';
  var pending = null;

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
      node = node.parentElement;
    }
    return true;
  }

  function build() {
    pending = null;

    var handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var current = document.getElementById(SCRIPT_ID);

    // A Liquid-rendered FAQPage for this exact collection is already in the
    // page source and is authoritative, so leave it untouched. The builder
    // only takes over after client-side navigation, and on the per-shape
    // pages whose FAQs come from the JSON asset.
    if (current && current.getAttribute('data-faq-handle') === handle) return;

    var mainEntity = [];
    var seen = {};

    document.querySelectorAll('[data-faq-schema]').forEach(function (block) {
      if (!isVisible(block)) return;

      block.querySelectorAll('.faq-item').forEach(function (item) {
        var questionEl = item.querySelector('.faq-question');
        var answerEl = item.querySelector('.faq-answer');
        if (!questionEl || !answerEl) return;

        var name = clean(questionEl.textContent);
        var text = clean(answerEl.innerHTML);
        var key = name.toLowerCase();
        if (!name || !text || seen[key]) return;

        seen[key] = true;
        mainEntity.push({
          '@type': 'Question',
          name: name,
          acceptedAnswer: { '@type': 'Answer', text: text }
        });
      });
    });

    var script = current;

    if (!mainEntity.length) {
      if (script) script.remove();
      return;
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    var pageUrl = (canonical && canonical.href) || (window.location.origin + window.location.pathname);

    var payload = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#faq',
      url: pageUrl,
      mainEntity: mainEntity
    });

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = SCRIPT_ID;
      document.head.appendChild(script);
    } else {
      script.removeAttribute('data-faq-handle');
    }

    if (script.textContent !== payload) script.textContent = payload;
  }

  return {
    sync: function () {
      if (pending !== null) return;
      pending = window.requestAnimationFrame
        ? window.requestAnimationFrame(build)
        : window.setTimeout(build, 0);
    }
  };
})();

let isLabDynamicLoading = false;
let labLastRenderKey = null;
let labOriginalMeta = null;

function getLabMetaDescriptionTag() {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  return tag;
}

function applyLabSeo(seo) {
  const metaTag = getLabMetaDescriptionTag();
  if (labOriginalMeta === null) {
    labOriginalMeta = { title: document.title, description: metaTag.getAttribute('content') || '' };
  }
  if (seo?.title) document.title = seo.title;
  if (seo?.description) metaTag.setAttribute('content', seo.description);
}

function restoreLabSeo() {
  if (!labOriginalMeta) return;
  document.title = labOriginalMeta.title;
  getLabMetaDescriptionTag().setAttribute('content', labOriginalMeta.description);
}

// Clones a family sub-template's markup next to itself into the live DOM (the <template> tag itself is left in place so it can be cloned again later); a no-op once already mounted, returns false only if the template is missing.
function mountLabSubTemplate(templateId, mountedId) {
  if (document.getElementById(mountedId)) return true;
  const tpl = document.getElementById(templateId);
  if (!tpl) return false;
  tpl.after(tpl.content.cloneNode(true));
  return !!document.getElementById(mountedId);
}

// Removes a previously-mounted clone from the live DOM entirely (not just display:none), so it can't be picked up by a crawl of a route it doesn't belong to; safe to call whether or not it's currently mounted.
function unmountLabSubTemplate(mountedId) {
  const el = document.getElementById(mountedId);
  if (el) el.remove();
}

function mountLabShapeTemplate() {
  return mountLabSubTemplate('tpl-lab-diamonds-shape', 'dynamic-category-content-lab');
}

function mountLabCaratTemplate() {
  return mountLabSubTemplate('tpl-lab-diamonds-carat', 'dynamic-category-content-lab-carat');
}

function mountLabSeoTemplate() {
  const mounted = mountLabSubTemplate('tpl-lab-diamonds-seo', 'lab-diamonds-seo-content');
  if (mounted) {
    const el = document.getElementById('lab-diamonds-seo-content');
    if (el) el.style.display = 'block';
  }
  return mounted;
}

function unmountAllLabSubTemplates() {
  unmountLabSubTemplate('dynamic-category-content-lab');
  unmountLabSubTemplate('dynamic-category-content-lab-carat');
  unmountLabSubTemplate('lab-diamonds-seo-content');
}

// Renders a shape's optional JSON-driven "sections" (heading/body/list/table/note), appended after the fixed guide content; absent for shapes that don't define it.
function renderLabSections(sections) {
  if (!Array.isArray(sections)) return '';

  return sections.map(function (section) {
    const listHtml = Array.isArray(section.list) && section.list.length
      ? `<ul>${section.list.map(item => `<li>${item}</li>`).join('')}</ul>`
      : '';

    const tableHtml = section.table && Array.isArray(section.table.rows)
      ? `
        <div class="faq-table-wrap">
          <table class="faq-table">
            <thead>
              <tr>${(section.table.headers || []).map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${section.table.rows.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
            </tbody>
          </table>
        </div>
      `
      : '';

    const noteHtml = section.note ? `<p class="faq-note">${section.note}</p>` : '';

    return `
      <div class="faq-subsection">
        <h2 class="faq-subheading">${section.heading || ''}</h2>
        ${section.body || ''}
        ${listHtml}
        ${tableHtml}
        ${noteHtml}
      </div>
    `;
  }).join('');
}

// Matches carat-size collection tag pages, e.g. '0-30-carat-diamond' (0.30ct)
// or '1-carat-diamond' (1ct). Separate from the `diamonds` shape allow-list
// below so any current or future carat size works without a hardcoded list.
const LAB_CARAT_HANDLE_RE = /^(\d+)(?:-(\d{2}))?-carat-diamond$/;

function parseLabCaratHandle(handle) {
  const match = LAB_CARAT_HANDLE_RE.exec(handle || '');
  if (!match) return null;
  return match[2] ? `${match[1]}.${match[2]}` : match[1];
}

function renderLabCaratFaq(caratLabel) {
  const caratContainer = document.getElementById('lab-carat-faq');
  if (!caratContainer) return;

  // The ring builder prints this description under its heading on desktop only, so phones get it here, above the FAQ.
  caratContainer.innerHTML = `
    <p class="text-center carat-page-mobile-desc">A ${caratLabel}ct lab grown diamond ring strikes the perfect balance between size and sparkle. Ideal for those who want a little more brilliance without a big budget, our collection features elegant and timeless ${caratLabel} carat engagement rings crafted with precision.</p>
    <h2 class="h2 text-center my-5">Frequently Asked Questions</h2>
    <div class="faq-item faq-item-1">
      <h3 class="h5 faq-question mb-0">
        <span>Is ${caratLabel}ct A Good Size For A Lab Grown Diamond Ring?</span>
        <span class="faq-icon"><i class="icon-plus"></i></span>
      </h3>
      <div class="faq-answer">Yes, it offers noticeable sparkle while remaining budget-friendly.</div>
    </div>
    <div class="faq-item">
      <h3 class="h5 faq-question mb-0">
        <span>What Shapes Are Best For ${caratLabel} Carat Lab Grown Diamond?</span>
        <span class="faq-icon"><i class="icon-plus"></i></span>
      </h3>
      <div class="faq-answer">Round, princess, and oval shapes are popular choices for ${caratLabel}ct lab grown diamond</div>
    </div>
    <div class="faq-item">
      <h3 class="h5 faq-question mb-0">
        <span>Can I Buy A ${caratLabel} Carat Lab Grown Diamond Ring Online In Australia?</span>
        <span class="faq-icon"><i class="icon-plus"></i></span>
      </h3>
      <div class="faq-answer">Absolutely. Rings of Australia provides secure and insured delivery across Australia.</div>
    </div>
  `;
  caratContainer.style.display = 'block';
  initLabFaqToggle();
}

/* =========================
   MAIN LOAD FUNCTION
========================= */

async function loadDynamicLabContent() {
  try {
    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];
    const handleParent = path[path.length - 2] || '';

    // Every category block is printed on every collection page, so the trailing
    // shape segment on its own is ambiguous: /collections/lab-diamonds/round and
    // /collections/natural-diamonds/round both end in 'round'. Key the render on
    // parent + handle so switching family client-side re-renders instead of
    // short-circuiting on a stale match.
    const currentRenderKey = `${handleParent}/${handle}`;

    // Check if already rendered for this URL to prevent duplicate runs & infinite mutation loops
    if (labLastRenderKey === currentRenderKey) {
      return;
    }

    if (isLabDynamicLoading) return;
    isLabDynamicLoading = true;

    // This physical page also hosts the natural/coloured-lab/moissanite/
    // engagement-rings flows. Only mount this family's template when the URL
    // is actually a lab-diamonds route, so those other routes (and a crawl
    // of any one of them) never find this family's headings sitting inert.
    const isLabFamilyRoute = handle === 'lab-diamonds' || handleParent === 'lab-diamonds';

    if (!isLabFamilyRoute) {
      unmountAllLabSubTemplates();
      restoreLabSeo();
      labLastRenderKey = currentRenderKey;
      isLabDynamicLoading = false;
      return;
    }

    // The base page, a carat sub-page and a shape sub-page are mutually exclusive routes, so only the template matching the current route is ever cloned in - the other two are removed outright (not just hidden) so a crawl of any one route only finds its own content.
    if (handle === 'lab-diamonds') {
      unmountLabSubTemplate('dynamic-category-content-lab');
      unmountLabSubTemplate('dynamic-category-content-lab-carat');
      mountLabSeoTemplate();
      restoreLabSeo();
      initLabFaqToggle();
      labLastRenderKey = currentRenderKey;
      isLabDynamicLoading = false;
      return;
    }

    const caratLabel = handleParent === 'lab-diamonds' ? parseLabCaratHandle(handle) : null;
    if (caratLabel !== null) {
      unmountLabSubTemplate('lab-diamonds-seo-content');
      unmountLabSubTemplate('dynamic-category-content-lab');
      mountLabCaratTemplate();
      renderLabCaratFaq(caratLabel);
      restoreLabSeo();
      labLastRenderKey = currentRenderKey;
      isLabDynamicLoading = false;
      return;
    }

    const diamonds = [
      'round','oval','pear','princess','asscher',
      'heart','emerald','radiant','cushion','marquise'
    ];

    // A shape page only belongs to this block when the parent segment is
    // 'lab-diamonds'. Without this check the same 'round' handle also opens the
    // natural and coloured blocks, printing the FAQ two more times.
    if (handleParent !== 'lab-diamonds' || !diamonds.includes(handle)) {
      unmountAllLabSubTemplates();
      restoreLabSeo();
      labLastRenderKey = currentRenderKey;
      isLabDynamicLoading = false;
      return;
    }

    unmountLabSubTemplate('lab-diamonds-seo-content');
    unmountLabSubTemplate('dynamic-category-content-lab-carat');

    if (!mountLabShapeTemplate()) {
      isLabDynamicLoading = false;
      return;
    }

    const container = document.getElementById('dynamic-category-content-lab');
    if (!container) {
      isLabDynamicLoading = false;
      return;
    }

    // A missing asset input, a 404 or an unreadable body all fall through to the
    // "no content" branch below, which records this route as handled. Without that,
    // the body-wide MutationObserver re-runs this loader - and re-fetches - on every DOM change.
    const assetInput = document.getElementById("dynamic-asseturl-lab");
    let data = null;
    if (assetInput && assetInput.value) {
      try {
        const response = await fetch(assetInput.value);
        if (response.ok) data = await response.json();
      } catch (jsonErr) {
        console.warn('Lab diamonds: could not load dynamic-category-content-lab.json', jsonErr);
      }
    }

    const content = data?.[`${handle}-lab-diamonds`];
    if (!content) {
      unmountLabSubTemplate('dynamic-category-content-lab');
      restoreLabSeo();
      labLastRenderKey = currentRenderKey;
      isLabDynamicLoading = false;
      return;
    }

    container.style.display = 'block';

    /* =========================
       HANDLE TEXT
    ========================= */

    const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);

    container.querySelectorAll('.lab-dynamic-handle-1')
      .forEach(el => el.innerText = handle1Text);

    container.querySelectorAll('.lab-dynamic-handle-2')
      .forEach(el => el.innerText = handle);

    /* =========================
       CONTENT INJECTION
    ========================= */

    const titleEl = container.querySelector('#lab-cat-title');
    const introEl = container.querySelector('#lab-cat-intro');
    const sectionsBlock = container.querySelector('#lab-dynamic-sections-block');
    const faqBlock = container.querySelector('#lab-dynamic-faq-block');

    // Shapes migrated to the ring-builder's seo/hero structure take those fields; shapes still on the older flat title/description fall back to them.
    if (titleEl) titleEl.innerHTML = content.hero?.heading || content.title || '';
    if (introEl) introEl.innerHTML = content.hero?.intro || content.description || '';
    applyLabSeo(content.seo);

    if (sectionsBlock) sectionsBlock.innerHTML = renderLabSections(content.sections);

    if (faqBlock && Array.isArray(content.faqs)) {
      faqBlock.innerHTML = `
        <div class="faq-container" data-faq-schema>
          <h2 class="h2 text-center my-5">Frequently Asked Questions</h2>
          ${content.faqs.map((f, i) => `
            <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
              <h3 class="h5 faq-question mb-0">
                <span>${f.q}</span>
                <span class="faq-icon"><i class="icon-plus"></i></span>
              </h3>
              <div class="faq-answer">${f.a}</div>
            </div>
          `).join('')}
        </div>
      `;
    }

    labLastRenderKey = currentRenderKey;
    initLabFaqToggle();

  } catch (err) {
    console.error('Lab Dynamic Error:', err);
  } finally {
    isLabDynamicLoading = false;
    window.pcFaqSchema.sync();
  }
}

/* =========================
   FAQ TOGGLE SAFE VERSION
========================= */

function initLabFaqToggle() {
  const container = document.getElementById('dynamic-category-content-lab');
  const caratContainer = document.getElementById('dynamic-category-content-lab-carat');
  const seoContent = document.getElementById('lab-diamonds-seo-content');

  const queryAndInit = (parent) => {
    if (!parent) return;
    parent.querySelectorAll('.faq-question').forEach(item => {
      if (item.dataset.listener === "true") return;
      item.dataset.listener = "true";

      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        let icon = item.querySelector('.faq-icon i') || item.querySelector('i');
        if (!answer) return;

        const isOpen = answer.classList.contains('active');

        parent.querySelectorAll('.faq-answer')
          .forEach(a => a.classList.remove('active'));

        parent.querySelectorAll('.faq-question i')
          .forEach(i => i.className = 'icon-plus');

        if (!isOpen) {
          answer.classList.add('active');
          if (icon) icon.className = 'icon-minus';
        }
      });
    });
  };

  queryAndInit(container);
  queryAndInit(caratContainer);
  queryAndInit(seoContent);
}

/* =========================
   INITIAL LOAD & OBSERVER
========================= */

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  loadDynamicLabContent();
} else {
  document.addEventListener('DOMContentLoaded', loadDynamicLabContent);
}

if (typeof window.labObserver === 'undefined') {
  window.labObserver = new MutationObserver(() => {
    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];
    const handleParent = path[path.length - 2] || '';
    if (labLastRenderKey !== `${handleParent}/${handle}`) {
      loadDynamicLabContent();
    }
  });
  window.labObserver.observe(document.body, { childList: true, subtree: true });
}

/* =========================
   SHOPIFY AJAX SAFE NAV
========================= */

if (typeof window.__pcUrlChangePatched === 'undefined') {
  window.__pcUrlChangePatched = true;
  (function () {
    ['pushState','replaceState'].forEach(method => {
      const original = history[method];
      history[method] = function () {
        original.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };
    });
    window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('urlChange'));
    });
  })();
}

window.addEventListener('urlChange', () => {
  setTimeout(() => {
    loadDynamicLabContent();
  }, 100);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-moissanite-diamonds"] && !Shopify.designMode) return;
  try {
    /* =========================
   FAQ JSON-LD SCHEMA (SHARED, HANDLE AWARE)
   Every category block is printed on every collection page and only
   the one matching the current handle is un-hidden. The schema is
   therefore built from the FAQ block that is actually visible, so a
   page never publishes another category's questions.
========================= */

window.pcFaqSchema = window.pcFaqSchema || (function () {
  var SCRIPT_ID = 'pc-faq-schema';
  var pending = null;

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
      node = node.parentElement;
    }
    return true;
  }

  function build() {
    pending = null;

    var handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var current = document.getElementById(SCRIPT_ID);

    // A Liquid-rendered FAQPage for this exact collection is already in the
    // page source and is authoritative, so leave it untouched. The builder
    // only takes over after client-side navigation, and on the per-shape
    // pages whose FAQs come from the JSON asset.
    if (current && current.getAttribute('data-faq-handle') === handle) return;

    var mainEntity = [];
    var seen = {};

    document.querySelectorAll('[data-faq-schema]').forEach(function (block) {
      if (!isVisible(block)) return;

      block.querySelectorAll('.faq-item').forEach(function (item) {
        var questionEl = item.querySelector('.faq-question');
        var answerEl = item.querySelector('.faq-answer');
        if (!questionEl || !answerEl) return;

        var name = clean(questionEl.textContent);
        var text = clean(answerEl.innerHTML);
        var key = name.toLowerCase();
        if (!name || !text || seen[key]) return;

        seen[key] = true;
        mainEntity.push({
          '@type': 'Question',
          name: name,
          acceptedAnswer: { '@type': 'Answer', text: text }
        });
      });
    });

    var script = current;

    if (!mainEntity.length) {
      if (script) script.remove();
      return;
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    var pageUrl = (canonical && canonical.href) || (window.location.origin + window.location.pathname);

    var payload = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#faq',
      url: pageUrl,
      mainEntity: mainEntity
    });

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = SCRIPT_ID;
      document.head.appendChild(script);
    } else {
      script.removeAttribute('data-faq-handle');
    }

    if (script.textContent !== payload) script.textContent = payload;
  }

  return {
    sync: function () {
      if (pending !== null) return;
      pending = window.requestAnimationFrame
        ? window.requestAnimationFrame(build)
        : window.setTimeout(build, 0);
    }
  };
})();

/* =========================
   SHOW/HIDE BASED ON COLLECTION HANDLE
========================= */

function loadDynamicMoissaniteContent() {
  const seoContent = document.getElementById('moissanite-diamonds-seo-content');
  if (!seoContent) return;

  const path = window.location.pathname.split('/').filter(Boolean);
  const collectionHandle = path[path.length - 1] || '';
  const handleParent = path[path.length - 2] || '';

  // Picking a shape rewrites the URL to /collections/moissanite-diamonds/<shape>,
  // so the family handle moves into the parent segment. Key the render on
  // parent + handle so navigating between shapes, or away to another family,
  // re-evaluates instead of short-circuiting on a stale match.
  const currentRenderKey = `${handleParent}/${collectionHandle}`;

  if (seoContent.dataset.renderedHandle === currentRenderKey) {
    return;
  }

  // Moissanite has no per-shape content of its own, unlike the lab, natural and
  // coloured blocks, so the family block stays up for every URL in the family.
  // Without the parent check the page goes blank the moment a shape is picked.
  const isMoissaniteFamily =
    collectionHandle === 'moissanite-diamonds' || handleParent === 'moissanite-diamonds';

  seoContent.style.display = isMoissaniteFamily ? 'block' : 'none';
  seoContent.dataset.renderedHandle = currentRenderKey;

  initMoissaniteFaqToggle();
  window.pcFaqSchema.sync();
}

/* =========================
   FAQ TOGGLE (SAFE VERSION)
========================= */

function initMoissaniteFaqToggle() {
  const seoContent = document.getElementById('moissanite-diamonds-seo-content');
  if (!seoContent) return;

  seoContent.querySelectorAll('.faq-question').forEach(item => {
    if (item.dataset.listener === "true") return;
    item.dataset.listener = "true";

    item.addEventListener('click', () => {
      const answer = item.nextElementSibling;
      let icon = item.querySelector('.faq-icon i') || item.querySelector('i');
      if (!answer) return;

      const isOpen = answer.classList.contains('active');

      seoContent.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('active'));
      seoContent.querySelectorAll('.faq-question i').forEach(i => i.className = 'icon-plus');

      if (!isOpen) {
        answer.classList.add('active');
        if (icon) icon.className = 'icon-minus';
      }
    });
  });
}

/* =========================
   INITIAL LOAD & OBSERVER
========================= */

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  loadDynamicMoissaniteContent();
} else {
  document.addEventListener('DOMContentLoaded', loadDynamicMoissaniteContent);
}

if (typeof window.moissaniteObserver === 'undefined') {
  window.moissaniteObserver = new MutationObserver(() => {
    const seoContent = document.getElementById('moissanite-diamonds-seo-content');
    if (seoContent) {
      const path = window.location.pathname.split('/').filter(Boolean);
      const collectionHandle = path[path.length - 1] || '';
      const handleParent = path[path.length - 2] || '';
      if (seoContent.dataset.renderedHandle !== `${handleParent}/${collectionHandle}`) {
        loadDynamicMoissaniteContent();
      }
    }
  });
  window.moissaniteObserver.observe(document.body, { childList: true, subtree: true });
}

/* =========================
   POLLING FALLBACK
   Catches route changes that neither mutate the DOM
   nor call history.pushState/replaceState directly.
========================= */

if (typeof window.moissanitePollInterval === 'undefined') {
  window.moissanitePollInterval = setInterval(() => {
    const seoContent = document.getElementById('moissanite-diamonds-seo-content');
    if (seoContent) {
      const path = window.location.pathname.split('/').filter(Boolean);
      const collectionHandle = path[path.length - 1] || '';
      const handleParent = path[path.length - 2] || '';
      if (seoContent.dataset.renderedHandle !== `${handleParent}/${collectionHandle}`) {
        loadDynamicMoissaniteContent();
      }
    }
  }, 400);
}

/* =========================
   SHOPIFY AJAX SAFE NAV
========================= */

if (typeof window.__pcUrlChangePatched === 'undefined') {
  window.__pcUrlChangePatched = true;
  (function () {
    ['pushState', 'replaceState'].forEach(method => {
      const original = history[method];
      history[method] = function () {
        original.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };
    });
    window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('urlChange'));
    });
  })();
}

window.addEventListener('urlChange', () => {
  setTimeout(() => {
    loadDynamicMoissaniteContent();
  }, 100);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-natural-diamonds"] && !Shopify.designMode) return;
  try {
    /* =========================
   FAQ JSON-LD SCHEMA (SHARED, HANDLE AWARE)
   Every category block is printed on every collection page and only
   the one matching the current handle is un-hidden. The schema is
   therefore built from the FAQ block that is actually visible, so a
   page never publishes another category's questions.
========================= */

window.pcFaqSchema = window.pcFaqSchema || (function () {
  var SCRIPT_ID = 'pc-faq-schema';
  var pending = null;

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
      node = node.parentElement;
    }
    return true;
  }

  function build() {
    pending = null;

    var handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var current = document.getElementById(SCRIPT_ID);

    // A Liquid-rendered FAQPage for this exact collection is already in the
    // page source and is authoritative, so leave it untouched. The builder
    // only takes over after client-side navigation, and on the per-shape
    // pages whose FAQs come from the JSON asset.
    if (current && current.getAttribute('data-faq-handle') === handle) return;

    var mainEntity = [];
    var seen = {};

    document.querySelectorAll('[data-faq-schema]').forEach(function (block) {
      if (!isVisible(block)) return;

      block.querySelectorAll('.faq-item').forEach(function (item) {
        var questionEl = item.querySelector('.faq-question');
        var answerEl = item.querySelector('.faq-answer');
        if (!questionEl || !answerEl) return;

        var name = clean(questionEl.textContent);
        var text = clean(answerEl.innerHTML);
        var key = name.toLowerCase();
        if (!name || !text || seen[key]) return;

        seen[key] = true;
        mainEntity.push({
          '@type': 'Question',
          name: name,
          acceptedAnswer: { '@type': 'Answer', text: text }
        });
      });
    });

    var script = current;

    if (!mainEntity.length) {
      if (script) script.remove();
      return;
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    var pageUrl = (canonical && canonical.href) || (window.location.origin + window.location.pathname);

    var payload = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#faq',
      url: pageUrl,
      mainEntity: mainEntity
    });

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = SCRIPT_ID;
      document.head.appendChild(script);
    } else {
      script.removeAttribute('data-faq-handle');
    }

    if (script.textContent !== payload) script.textContent = payload;
  }

  return {
    sync: function () {
      if (pending !== null) return;
      pending = window.requestAnimationFrame
        ? window.requestAnimationFrame(build)
        : window.setTimeout(build, 0);
    }
  };
})();

let isNaturalDynamicLoading = false;
let naturalLastRenderKey = null;
let naturalOriginalMeta = null;

function getNaturalMetaDescriptionTag() {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  return tag;
}

function applyNaturalSeo(seo) {
  const metaTag = getNaturalMetaDescriptionTag();
  if (naturalOriginalMeta === null) {
    naturalOriginalMeta = { title: document.title, description: metaTag.getAttribute('content') || '' };
  }
  if (seo?.title) document.title = seo.title;
  if (seo?.description) metaTag.setAttribute('content', seo.description);
}

function restoreNaturalSeo() {
  if (!naturalOriginalMeta) return;
  document.title = naturalOriginalMeta.title;
  getNaturalMetaDescriptionTag().setAttribute('content', naturalOriginalMeta.description);
}

// Renders a shape's optional JSON-driven "sections" (heading/body/list/table/note), appended after the fixed guide content; absent for shapes that don't define it.
function renderNaturalSections(sections) {
  if (!Array.isArray(sections)) return '';

  return sections.map(function (section) {
    const listHtml = Array.isArray(section.list) && section.list.length
      ? `<ul>${section.list.map(item => `<li>${item}</li>`).join('')}</ul>`
      : '';

    const tableHtml = section.table && Array.isArray(section.table.rows)
      ? `
        <div class="faq-table-wrap">
          <table class="faq-table">
            <thead>
              <tr>${(section.table.headers || []).map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${section.table.rows.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
            </tbody>
          </table>
        </div>
      `
      : '';

    const noteHtml = section.note ? `<p class="faq-note">${section.note}</p>` : '';

    return `
      <div class="faq-subsection">
        <h2 class="faq-subheading">${section.heading || ''}</h2>
        ${section.body || ''}
        ${listHtml}
        ${tableHtml}
        ${noteHtml}
      </div>
    `;
  }).join('');
}

// Clones a family sub-template's markup next to itself into the live DOM. The
// <template> tag itself is left in place (never consumed) so it can be cloned
// from again later; a no-op once already mounted. Returns false only if the
// template is missing.
function mountNaturalSubTemplate(templateId, mountedId) {
  if (document.getElementById(mountedId)) return true;
  const tpl = document.getElementById(templateId);
  if (!tpl) return false;
  tpl.after(tpl.content.cloneNode(true));
  return !!document.getElementById(mountedId);
}

// Removes a previously-mounted clone from the live DOM entirely (not just
// display:none) so it can't be picked up by a crawl of a route it doesn't
// belong to. Safe to call whether or not it's currently mounted.
function unmountNaturalSubTemplate(mountedId) {
  const el = document.getElementById(mountedId);
  if (el) el.remove();
}

function mountNaturalShapeTemplate() {
  return mountNaturalSubTemplate('tpl-natural-diamonds-shape', 'dynamic-category-content-natural');
}

function mountNaturalCaratTemplate() {
  return mountNaturalSubTemplate('tpl-natural-diamonds-carat', 'dynamic-category-content-natural-carat');
}

function mountNaturalSeoTemplate() {
  const mounted = mountNaturalSubTemplate('tpl-natural-diamonds-seo', 'natural-diamonds-seo-content');
  if (mounted) {
    const el = document.getElementById('natural-diamonds-seo-content');
    if (el) el.style.display = 'block';
  }
  return mounted;
}

function unmountAllNaturalSubTemplates() {
  unmountNaturalSubTemplate('dynamic-category-content-natural');
  unmountNaturalSubTemplate('dynamic-category-content-natural-carat');
  unmountNaturalSubTemplate('natural-diamonds-seo-content');
}

// Matches carat-size collection tag pages, e.g. '0-30-carat-diamond' (0.30ct)
// or '1-carat-diamond' (1ct). Separate from the `diamonds` shape allow-list
// below so any current or future carat size works without a hardcoded list.
const NATURAL_CARAT_HANDLE_RE = /^(\d+)(?:-(\d{2}))?-carat-diamond$/;

function parseNaturalCaratHandle(handle) {
  const match = NATURAL_CARAT_HANDLE_RE.exec(handle || '');
  if (!match) return null;
  return match[2] ? `${match[1]}.${match[2]}` : match[1];
}

function renderNaturalCaratFaq(caratLabel) {
  const caratContainer = document.getElementById('natural-carat-faq');
  if (!caratContainer) return;

  // The ring builder prints this description under its heading on desktop only, so phones get it here, above the FAQ.
  caratContainer.innerHTML = `
    <p class="text-center carat-page-mobile-desc">A ${caratLabel}ct natural diamond ring strikes the perfect balance between size and sparkle. Ideal for those who want a little more brilliance without a big budget, our collection features elegant and timeless ${caratLabel} carat engagement rings crafted with precision.</p>
    <h2 class="h2 text-center my-5">Frequently Asked Questions</h2>
    <div class="faq-item faq-item-1">
      <h3 class="h5 faq-question mb-0">
        <span>Is ${caratLabel}ct A Good Size For A Natural Diamond Ring?</span>
        <span class="faq-icon"><i class="icon-plus"></i></span>
      </h3>
      <div class="faq-answer">Yes, it offers noticeable sparkle while remaining budget-friendly.</div>
    </div>
    <div class="faq-item">
      <h3 class="h5 faq-question mb-0">
        <span>What Shapes Are Best For ${caratLabel} Carat Natural Diamond?</span>
        <span class="faq-icon"><i class="icon-plus"></i></span>
      </h3>
      <div class="faq-answer">Round, princess, and oval shapes are popular choices for ${caratLabel}ct natural diamond</div>
    </div>
    <div class="faq-item">
      <h3 class="h5 faq-question mb-0">
        <span>Can I Buy A ${caratLabel} Carat Natural Diamond Ring Online In Australia?</span>
        <span class="faq-icon"><i class="icon-plus"></i></span>
      </h3>
      <div class="faq-answer">Absolutely. Rings of Australia provides secure and insured delivery across Australia.</div>
    </div>
  `;
  caratContainer.style.display = 'block';
  initNaturalFaqToggle();
}

/* =========================
   MAIN LOAD FUNCTION
========================= */

async function loadDynamicNaturalContent() {
  try {
    const path = window.location.pathname.split('/').filter(Boolean);
    const collectionHandle = path[path.length - 1] || '';
    const handleParent = path[path.length - 2] || '';

    // Every category block is printed on every collection page, so the trailing
    // shape segment on its own is ambiguous: /collections/natural-diamonds/round
    // and /collections/lab-diamonds/round both end in 'round'. Key the render on
    // parent + handle so switching family client-side re-renders instead of
    // short-circuiting on a stale match.
    const currentRenderKey = `${handleParent}/${collectionHandle}`;

    // Check if already rendered for this URL to prevent duplicate runs & infinite mutation loops
    if (naturalLastRenderKey === currentRenderKey) {
      return;
    }

    if (isNaturalDynamicLoading) return;
    isNaturalDynamicLoading = true;

    // This physical page also hosts the lab/coloured-lab/moissanite/
    // engagement-rings flows. Only mount this family's template when the URL
    // is actually a natural-diamonds route, so those other routes (and a
    // crawl of any one of them) never find this family's headings inert.
    const isNaturalFamilyRoute =
      collectionHandle === 'natural-diamonds' || handleParent === 'natural-diamonds';

    if (!isNaturalFamilyRoute) {
      unmountAllNaturalSubTemplates();
      restoreNaturalSeo();
      naturalLastRenderKey = currentRenderKey;
      isNaturalDynamicLoading = false;
      return;
    }

    // The base page, a carat sub-page and a shape sub-page are mutually
    // exclusive routes within this family, so only the template matching the
    // current route is ever cloned in; the other two are removed outright
    // (not just hidden) so a crawl of any one route only finds its own content.
    if (collectionHandle === 'natural-diamonds') {
      unmountNaturalSubTemplate('dynamic-category-content-natural');
      unmountNaturalSubTemplate('dynamic-category-content-natural-carat');
      mountNaturalSeoTemplate();
      restoreNaturalSeo();
      initNaturalFaqToggle();
      naturalLastRenderKey = currentRenderKey;
      isNaturalDynamicLoading = false;
      return;
    }

    const caratLabel = handleParent === 'natural-diamonds'
      ? parseNaturalCaratHandle(collectionHandle)
      : null;
    if (caratLabel !== null) {
      unmountNaturalSubTemplate('natural-diamonds-seo-content');
      unmountNaturalSubTemplate('dynamic-category-content-natural');
      mountNaturalCaratTemplate();
      renderNaturalCaratFaq(caratLabel);
      restoreNaturalSeo();
      naturalLastRenderKey = currentRenderKey;
      isNaturalDynamicLoading = false;
      return;
    }

    const diamonds = [
      'round','oval','pear','princess','asscher',
      'heart','emerald','radiant','cushion','marquise'
    ];

    // A shape page only belongs to this block when the parent segment is
    // 'natural-diamonds'. Without this check the same 'round' handle also opens
    // the lab and coloured blocks, printing the FAQ two more times. The match is
    // exact rather than a substring so 'round-something-else' cannot slip in.
    const handle = handleParent === 'natural-diamonds'
      ? diamonds.find(d => d === collectionHandle)
      : undefined;
    if (!handle) {
      unmountAllNaturalSubTemplates();
      restoreNaturalSeo();
      naturalLastRenderKey = currentRenderKey;
      isNaturalDynamicLoading = false;
      return;
    }

    unmountNaturalSubTemplate('natural-diamonds-seo-content');
    unmountNaturalSubTemplate('dynamic-category-content-natural-carat');

    if (!mountNaturalShapeTemplate()) {
      isNaturalDynamicLoading = false;
      return;
    }

    const container = document.getElementById('dynamic-category-content-natural');
    if (!container) {
      isNaturalDynamicLoading = false;
      return;
    }

    // A missing asset input, a 404 or an unreadable body all fall through to the
    // "no content" branch below, which records this route as handled. Without that,
    // the body-wide MutationObserver re-runs this loader - and re-fetches - on every DOM change.
    const assetInput = document.getElementById("dynamic-asseturl-natural");
    let data = null;
    if (assetInput && assetInput.value) {
      try {
        const response = await fetch(assetInput.value);
        if (response.ok) data = await response.json();
      } catch (jsonErr) {
        console.warn('Natural diamonds: could not load dynamic-category-content-natural.json', jsonErr);
      }
    }

    const content = data?.[`${handle}-natural-diamonds`];
    if (!content) {
      unmountNaturalSubTemplate('dynamic-category-content-natural');
      restoreNaturalSeo();
      naturalLastRenderKey = currentRenderKey;
      isNaturalDynamicLoading = false;
      return;
    }

    container.style.display = 'block';

    /* =========================
       HANDLE TEXT FIXED
    ========================= */

    const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);

    container.querySelectorAll('.natural-dynamic-handle-1')
      .forEach(el => el.textContent = handle1Text);

    container.querySelectorAll('.natural-dynamic-handle-2')
      .forEach(el => el.textContent = handle);

    /* =========================
       CONTENT INJECTION
    ========================= */

    const titleEl = container.querySelector('#natural-cat-title');
    const introEl = container.querySelector('#natural-cat-intro');
    const sectionsBlock = container.querySelector('#natural-dynamic-sections-block');
    const faqBlock = container.querySelector('#natural-dynamic-faq-block');

    // Shapes migrated to the ring-builder's seo/hero structure take those fields; shapes still on the older flat title/description fall back to them.
    if (titleEl) titleEl.innerHTML = content.hero?.heading || content.title || '';
    if (introEl) introEl.innerHTML = content.hero?.intro || content.description || '';
    applyNaturalSeo(content.seo);

    if (sectionsBlock) sectionsBlock.innerHTML = renderNaturalSections(content.sections);

    if (faqBlock && Array.isArray(content.faqs)) {
      faqBlock.innerHTML = `
        <div class="faq-container" data-faq-schema>
          <h2 class="h2 text-center mb-5">Frequently Asked Questions</h2>
          ${content.faqs.map((f, i) => `
            <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
              <h3 class="faq-question h5 mb-0">
                <span>${f.q}</span>
                <span class="faq-icon"><i class="icon-plus"></i></span>
              </h3>
              <div class="faq-answer">${f.a}</div>
            </div>
          `).join('')}
        </div>
      `;
    }

    naturalLastRenderKey = currentRenderKey;
    initNaturalFaqToggle();

  } catch (err) {
    console.error('Natural Dynamic Error:', err);
  } finally {
    isNaturalDynamicLoading = false;
    window.pcFaqSchema.sync();
  }
}

/* =========================
   FAQ TOGGLE SAFE VERSION
========================= */

function initNaturalFaqToggle() {
  const container = document.getElementById('dynamic-category-content-natural');
  const caratContainer = document.getElementById('dynamic-category-content-natural-carat');
  const seoContent = document.getElementById('natural-diamonds-seo-content');

  const queryAndInit = (parent) => {
    if (!parent) return;
    parent.querySelectorAll('.faq-question').forEach(item => {
      if (item.dataset.listener === "true") return;
      item.dataset.listener = "true";

      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        let icon = item.querySelector('.faq-icon i') || item.querySelector('i');
        if (!answer) return;

        const isOpen = answer.classList.contains('active');

        parent.querySelectorAll('.faq-answer')
          .forEach(a => a.classList.remove('active'));

        parent.querySelectorAll('.faq-question i')
          .forEach(i => i.className = 'icon-plus');

        if (!isOpen) {
          answer.classList.add('active');
          if (icon) icon.className = 'icon-minus';
        }
      });
    });
  };

  queryAndInit(container);
  queryAndInit(caratContainer);
  queryAndInit(seoContent);
}

/* =========================
   INITIAL LOAD & OBSERVER
========================= */

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  loadDynamicNaturalContent();
} else {
  document.addEventListener('DOMContentLoaded', loadDynamicNaturalContent);
}

if (typeof window.naturalObserver === 'undefined') {
  window.naturalObserver = new MutationObserver(() => {
    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1] || '';
    const handleParent = path[path.length - 2] || '';
    if (naturalLastRenderKey !== `${handleParent}/${handle}`) {
      loadDynamicNaturalContent();
    }
  });
  window.naturalObserver.observe(document.body, { childList: true, subtree: true });
}

/* =========================
   SHOPIFY AJAX SAFE NAV
========================= */

if (typeof window.__pcUrlChangePatched === 'undefined') {
  window.__pcUrlChangePatched = true;
  (function () {
    ['pushState','replaceState'].forEach(method => {
      const original = history[method];
      history[method] = function () {
        original.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };
    });
    window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('urlChange'));
    });
  })();
}

window.addEventListener('urlChange', () => {
  setTimeout(() => {
    loadDynamicNaturalContent();
  }, 100);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-bands"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.h5').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-bracelets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-diamond"] && !Shopify.designMode) return;
  try {
    (function () {
    let lastKey = null;
    let requestId = 0;
    let faqDataPromise = null;

    function loadDiamondContent() {
      const container = document.querySelector('.roa-diamond-container');
      if (!container) return

      const pathParts = window.location.pathname.replace(/^\/+|\/+$/g, '').split('/');
      const collectionHandle = pathParts[1];
      const diamondType = (pathParts[2] || '').toLowerCase();

      const categoryMap = {
        'coloured-lab-grown-diamonds': 'coloured-lab-grown-diamonds',
        'lab-diamonds': 'lab-diamonds',
        'natural-diamonds': 'natural-diamonds',
      };
      const diamondCategory = categoryMap[collectionHandle];

      // Shape-keyed content only. Base pages and carat pages (0-30-carat-diamond etc.) have no
      // entry in the JSON below, so hide the block rather than render empty or stale headings.
      const diamondShapes = ['asscher','cushion','emerald','heart','marquise','oval','pear','princess','radiant','round'];
      if (!diamondCategory || !diamondShapes.includes(diamondType)) {
        requestId++;
        lastKey = null;
        container.style.display = 'none';
        return
      }

      // Already showing this exact category/shape (and the container wasn't re-created by a re-render).
      const key = diamondCategory + '/' + diamondType;
      if (key === lastKey && container.dataset.renderedKey === key) return
      lastKey = key;
      const currentRequest = ++requestId;

      // Clear the previous shape's content right away so old copy never lingers while the JSON loads.
      container.querySelector('.roa-diamond-title').textContent = '';
      container.querySelector('.roa-diamond-paragraphs').innerHTML = '';
      container.querySelector('.roa-diamond-faq-list').innerHTML = '';
      container.style.display = '';

      const diamondShape = diamondType.charAt(0).toUpperCase() + diamondType.slice(1);

      // --- static data setup (keep your staticData object here exactly as before) ---
      const staticData = {
        'coloured-lab-grown-diamonds': {
          title: `Why Choose Rings of Australia for ${diamondShape} Lab-Grown Coloured Diamonds`,
          highlights: [
            'Australia’s Lowest Price for Certified Lab-Grown Coloured Diamonds',
            'IGI Certified for Quality and Authenticity',
            'FREE Custom Design – Personalise your ring with your favourite fancy colour',
            `<a href="https://ringsofaustralia.com.au/pages/shipping" target="_blank">FREE Shipping Across Australia </a>`,
            'Fast Delivery (Under 4 Weeks)',
            `40% Off on <a href="https://ringsofaustralia.com.au/collections/coloured-lab-grown-diamonds" target="_blank" style="text-decoration:underline;">Lab-Grown Coloured Diamonds</a>`,
            `<a href="https://ringsofaustralia.com.au/collections/lab-diamonds" target="_blank" style="text-decoration:underline;">Price Match Guarantee</a>`,
            'Sustainable, Ethical & Conflict-Free',
          ],
          specs: {
            'Diamond Clarity': 'FL, IF, VVS1, VVS2, VS1, VS2, SI1',
            'Available Fancy Colours': 'Pink, Yellow, Blue, Red, and Green',
            Applications: `
            <a href="https://ringsofaustralia.com.au/collections/engagement-rings" target="_blank">Engagement Rings</a>, 
            <a href="https://ringsofaustralia.com.au/collections/womens-wedding-bands" target="_blank">Wedding Rings</a>, 
            Pendants,Earrings, Bracelets
            `,
            Occasions: 'Engagements, Anniversaries, Birthdays, Luxury Celebrations',
          },
          sizes: [
            { size: '1–2 Carat Pink / Yellow / Blue', bestFor: 'Elegant and minimalist engagement rings' },
            {
              size: '2–3 Carat Pink / Yellow / Blue',
              bestFor: 'Modern statement rings and fine jewellery',
            },
            { size: '3–5 Carat Pink / Yellow / Blue', bestFor: 'Luxurious, custom-designed creations' },
          ],
          sizeHeading: 'Popular Sizes & Fancy Colours',
        },
        'lab-diamonds': {
          title: `Why Choose Rings of Australia for ${diamondShape} Lab-Grown Diamonds`,
          highlights: [
            'Lowest Price in Australia',
            'FREE Custom Design (Create your dream ring with our diamonds)',
            `<a href="https://ringsofaustralia.com.au/pages/shipping" target="_blank">FREE Shipping Across Australia </a>`,
            'Fastest Delivery (Within 4 weeks)',
            `<a href="https://ringsofaustralia.com.au/pages/book-virtual-appointment" target="_blank" style="text-decoration:underline;">24/7 Customer Support </a>`,
            'Premium Quality & IGI Certified Diamonds',
            `40% Off on <a href="https://ringsofaustralia.com.au/collections/lab-diamonds" target="_blank" style="text-decoration:underline;">Lab-Grown Diamonds</a>`,
            `<a href="https://ringsofaustralia.com.au/collections/lab-diamonds" target="_blank" style="text-decoration:underline;">Price Match Guarantee</a>`,
          ],
          specs: {
            'Diamond Cuts': 'Ideal, Excellent, Very Good, Good',
            'Diamond Colour': 'D, E, F, G, H, I, J, K',
            'Diamond Clarity': 'FL, IF, VVS1, VVS2, VS1, VS2, SI1',
            Applications: `
            <a href="https://ringsofaustralia.com.au/collections/engagement-rings" target="_blank">Engagement Rings</a>, 
            <a href="https://ringsofaustralia.com.au/collections/womens-wedding-bands" target="_blank">Wedding Rings</a>, 
            Pendants,Earrings, Bracelets
            `,
          },
          sizes: [
            { size: '1 Carat', bestFor: 'Elegant and classic for engagement rings' },
            { size: '1.5 Carat', bestFor: 'Balanced and brilliant choice' },
            { size: '2 Carat', bestFor: 'Luxurious and eye-catching centrepiece' },
            { size: '3 Carat', bestFor: 'Statement piece for signature rings' },
            { size: '4–5 Carat', bestFor: 'Impressive size for custom designs' },
          ],
          sizeHeading: 'Popular Sizes',
        },
        'natural-diamonds': {
          title: `Why Choose Rings of Australia for ${diamondShape} Natural Diamonds`,
          highlights: [
            `Lowest Price for Certified<a href="https://ringsofaustralia.com.au/collections/natural-diamonds" target="_blank">Natural Diamonds </a>in Australia`,
            'GIA & IGI Certified for Authenticity and Quality',
            'FREE Custom Design (Create your dream ring with our natural diamonds)',
            `<a href="https://ringsofaustralia.com.au/pages/shipping" target="_blank">FREE Shipping Across Australia</a>`,
            'Fastest Delivery (Under 4 Weeks)',
            'Ethically Sourced & Conflict-Free Diamonds',
            `<a href="https://ringsofaustralia.com.au/pages/price-match-guarantee" target="_blank">Price Match Guarantee</a> on Natural Diamonds`,
          ],
          specs: {
            'Diamond Cuts': 'Ideal, Excellent, Very Good, Good',
            'Diamond Colour': 'D, E, F, G, H, I, J, K',
            'Diamond Clarity': 'FL, IF, VVS1, VVS2, VS1, VS2, SI1',
            Applications: `<a href="https://ringsofaustralia.com.au/collections/engagement-rings" target="_blank" style="text-decoration:underline;">Engagement Rings</a> <a href="https://ringsofaustralia.com.au/collections/womens-wedding-bands" target="_blank" style="text-decoration:underline;">Wedding Rings</a>Pendants, Earrings, Bracelets`,
          },
          sizes: [
            { size: '1 Carat', bestFor: 'Graceful and timeless choice for engagement rings' },
            { size: '1.5 Carat', bestFor: 'Elegant size with brilliant fire and balance' },
            { size: '2 Carat', bestFor: 'Luxurious option for classic and modern designs' },
            { size: '2.5 Carat', bestFor: 'Perfect for statement or heirloom jewellery' },
            { size: '3–5 Carat', bestFor: 'Striking brilliance for custom or high-end creations' },
          ],
          sizeHeading: 'Popular Sizes',
        },
      };
      const staticInfo = staticData[diamondCategory];
      if (!staticInfo) return 

      const staticHTML = `
      <div class="roa-container">
        <header class="roa-hero">
         <h2 class=" h3 roa-title">${staticInfo.title}</h2>
        </header>
        <div class="roa-highlights">
          <ul>${staticInfo.highlights.map((item) => `<li>${item}</li>`).join('')}</ul>
        </div>
        <section class="roa-specs">
          <h2 class="section-title">Our ${diamondShape} ${diamondCategory.replace(/-/g, ' ')} – Specifications</h2>
          <div class="spec-grid">
            ${Object.entries(staticInfo.specs)
              .map(
                ([key, val]) => `
                <div class="spec-item">
                  <h3>${key}</h3>
                  <p>${val}</p>
                </div>
              `
              )
              .join('')}
          </div>
        </section>
        <section class="roa-popular-sizes">
          <h2 class="section-title">${staticInfo.sizeHeading} for ${diamondShape} ${diamondCategory.replace(
        /-/g,
        ' '
      )}</h2>
          <div class="sizes-grid">
            ${staticInfo.sizes
              .map(
                (s) => `
                <div class="size-card">
                  <p class="size-name">${s.size} ${diamondShape} ${diamondCategory.replace(/-/g, ' ')}</p>
                  <p class="size-for"><strong>Best for:</strong> ${s.bestFor}</p>
                </div>`
              )
              .join('')}
          </div>
        </section>
      </div>
    `;

      const staticSection = document.querySelector('#roa-static-section');
      if (staticSection) staticSection.innerHTML = staticHTML;

      const jsonUrl = 'https://cdn.shopify.com/s/files/1/0900/1870/9868/files/diamond-faqs2.json?v=1764935173';
      if (!faqDataPromise) {
        faqDataPromise = fetch(jsonUrl)
          .then((res) => res.json())
          .catch((err) => {
            faqDataPromise = null;
            throw err;
          });
      }
      faqDataPromise
        .then((data) => {
          // The shopper may have switched shape/tab while the JSON was loading.
          if (currentRequest !== requestId) return
          container.dataset.renderedKey = key;
          const catObj = data[diamondCategory];
          const diamondData = catObj?.[diamondType];
          const faqsWrapper = container.querySelector('.roa-diamond-faqs');
          if (!diamondData) {
            if (faqsWrapper) faqsWrapper.style.display = 'none';
            return 
          }

          container.querySelector('.roa-diamond-title').textContent = diamondData.title;
          const paragraphContainer = container.querySelector('.roa-diamond-paragraphs');
          paragraphContainer.innerHTML = '';
          if (diamondData.paragraphs?.length > 0) {
            const firstPara = diamondData.paragraphs[0];
            const section = document.createElement('div');
            section.className = 'roa-diamond-paragraph';
            section.innerHTML = `<p>${firstPara.detail}</p>`;
            paragraphContainer.appendChild(section);
          }

          const faqList = container.querySelector('.roa-diamond-faq-list');
          faqList.innerHTML = '';
          if (faqsWrapper) faqsWrapper.style.display = diamondData.faqs?.length ? '' : 'none';

          (diamondData.faqs || []).forEach((faq) => {
            const faqItem = document.createElement('div');
            faqItem.className = 'roa-diamond-faq-item';
            const answerWithLink = faq.answer.replace(
              'FREE custom design',
              `<a href="/pages/customize-your-engagement-ring" class="faq-link">FREE custom design</a>`
            );
            faqItem.innerHTML = `
            <div class="roa-diamond-faq-question">${faq.question}<span>+</span></div>
            <div class="roa-diamond-faq-answer">${answerWithLink}</div>
          `;
            faqList.appendChild(faqItem);
          });

          faqList.querySelectorAll('.roa-diamond-faq-question').forEach((q) => {
            q.addEventListener('click', () => {
              const answer = q.nextElementSibling;
              const isActive = answer.classList.toggle('active');
              q.querySelector('span').textContent = isActive ? '–' : '+';
            });
          });
        })
        .catch((err) => console.error('❌ Error loading diamond data:', err));
    }

    // Run once initially
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadDiamondContent);
    } else {
      loadDiamondContent();
    }

    // Detect client-side URL changes made by the ring builder tabs/shape picker (pushState),
    // back/forward, and as a fallback any DOM change that happens after the URL moved on.
    if (!window.__roaDiamondFaqNavPatched) {
      window.__roaDiamondFaqNavPatched = true;
      ['pushState', 'replaceState'].forEach((method) => {
        const original = history[method];
        history[method] = function () {
          const result = original.apply(this, arguments);
          setTimeout(loadDiamondContent, 0);
          return result;
        };
      });
      window.addEventListener('popstate', loadDiamondContent);
    }

    let lastUrl = location.href;
    new MutationObserver(() => {
      const currentUrl = location.href;
      if (currentUrl !== lastUrl) {
        lastUrl = currentUrl;
        loadDiamondContent();
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-earrings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.h5').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-engagement-rings"] && !Shopify.designMode) return;
  try {
    /* Delegated rather than bound per element at DOMContentLoaded: switching setting style
     swaps in a different v-if branch, so Vue creates fresh question nodes that a one-off
     binding would never reach. Scoped to .er-faq-root so it only claims this snippet's
     questions and not the identically classed ones in the sibling FAQ snippets. */
  document.addEventListener('click', function (event) {
    const question = event.target.closest('.er-faq-root .faq-question');
    if (!question) return;

    const answer = question.nextElementSibling;
    if (!answer) return;

    const isOpen = answer.classList.toggle('active');
    const toggle = question.querySelector('.faq-icon');
    if (toggle) {
      toggle.innerHTML = isOpen ? `<i class="icon-minus"></i>` : `<i class="icon-plus"></i>`;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-fine-jewellery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-mens-bands"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.h5').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-pendants"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
